/**
 * Family registration fee – co-op-wide amount stored in site settings (cents).
 */

export const DEFAULT_FAMILY_REGISTRATION_FEE_CENTS = 3000;

export const MIN_FAMILY_REGISTRATION_FEE_CENTS = 0;
export const MAX_FAMILY_REGISTRATION_FEE_CENTS = 500_00; // $500.00

export function normalizeFamilyRegistrationFeeCents(value: unknown): number {
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) {
    return DEFAULT_FAMILY_REGISTRATION_FEE_CENTS;
  }
  const rounded = Math.round(n);
  if (rounded < MIN_FAMILY_REGISTRATION_FEE_CENTS) {
    return MIN_FAMILY_REGISTRATION_FEE_CENTS;
  }
  if (rounded > MAX_FAMILY_REGISTRATION_FEE_CENTS) {
    return MAX_FAMILY_REGISTRATION_FEE_CENTS;
  }
  return rounded;
}

/** USD display for whole-dollar amounts (e.g. 3000 → "$30"). */
export function formatFamilyRegistrationFeeUsd(cents: number): string {
  const normalized = normalizeFamilyRegistrationFeeCents(cents);
  const dollars = normalized / 100;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: dollars % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(dollars);
}
